import React from 'react';

const TrackerInfo: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-success-50 to-primary-50 dark:from-success-900/20 dark:to-primary-900/20 border border-success-200 dark:border-success-800 rounded-xl p-5">
      <div className="flex items-start">
        <div className="w-10 h-10 bg-gradient-to-br from-success-500 to-success-600 rounded-lg flex items-center justify-center shadow-soft mr-4 flex-shrink-0">
          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <div>
          <p className="font-semibold text-success-800 dark:text-success-300 mb-2">About Trackers</p>
          <p className="text-success-700 dark:text-success-400 text-sm leading-relaxed">
            Trackers help you monitor personal metrics over time.
            You can log values daily and see your progress on the calendar! 📈
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrackerInfo;
